export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SECONDS = 10;
export const RES_PER_PAGE = 10;
export const KEY = "0262c8ba-0dc0-473a-a0e9-ad570852e473";
export const MODAL_CLOSE_SEC = 2.5;
